import script from "./EditProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./EditProduct.vue?vue&type=script&setup=true&lang=js"

import "./EditProduct.vue?vue&type=style&index=0&id=d496b73c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d496b73c"]])

export default __exports__